import { useEffect, useState } from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { isEmpty } from 'lodash';

import AppState from '../../store/appstate';

function LdSetup({ ldClient }) {
  const authentication = AppState.useState((s) => s?.authentication);
  const isAuthed = !isEmpty(authentication);

  const [userName, setUserName] = useState('');
  useEffect(() => {
    if (ldClient && isAuthed
      && userName !== authentication.userName) {
      console.log(authentication);
      ldClient.identify({
        key: authentication.userSegmentKey,
      });
      setUserName(authentication.userName);
    }
  });

  return (<></>);
}

export default withLDConsumer()(LdSetup);
